// removed by extract-text-webpack-plugin
module.exports = {"box":"mini-loader__box___3x1wX","arrows":"mini-loader__arrows___2HHJ6","d1":"mini-loader__d1___1pR6W","d2":"mini-loader__d2___3XH_A","d3":"mini-loader__d3___2ToEE","d4":"mini-loader__d4___1V19O"};


//////////////////
// WEBPACK FOOTER
// ./src/loaders/mini-loader.scss
// module id = 636
// module chunks = 0